// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProfileAdminTools":"iz_a bic_vu bic_ql bic_va bic_gy bic_kg bic_sv","ProfileAdminTools__item":"iz_b"};